import RelationshipConsultor from "./RelationshipConsultor"
import MeditationTeacher from "./MeditationTeacher"
import MindfulnessCoach from "./MindfulnessCoach"
import SpiritualAdvisor from "./SpiritualAdvisor"
import StressManagement from "./StressManagement"
import TimeManagement from "./TimeManagement"
import ArtTherapist from "./ArtTherapist"
import Nutritionist from "./Nutritionist"
import CareerCoach from "./CareerCoach"
import YogaTeacher from "./YogaTeacher"
import SleepCoach from "./SleepCoach"
import Financial from "./Financial"
import LifeCoach from "./LifeCoach"
import Parenting from "./Parenting"
import Therapist from "./Therapist"
import Holistic from "./Holistic"
import TaiChi from "./TaiChi"

export const specializationComponents = {
  "67d90056c2c4d5ab747f8b33": RelationshipConsultor,
  "67d90056c2c4d5ab747f8b36": MeditationTeacher,
  "67d90056c2c4d5ab747f8b40": MindfulnessCoach,
  "67d90056c2c4d5ab747f8b41": SpiritualAdvisor,
  "67d90056c2c4d5ab747f8b3b": StressManagement,
  "67d90056c2c4d5ab747f8b3c": TimeManagement,
  "67d90056c2c4d5ab747f8b3e": ArtTherapist,
  "67d90056c2c4d5ab747f8b37": Nutritionist,
  "67d90056c2c4d5ab747f8b32": CareerCoach,
  "67d90056c2c4d5ab747f8b35": YogaTeacher,
  "67d90056c2c4d5ab747f8b3a": SleepCoach,
  "67d90056c2c4d5ab747f8b39": Financial,
  "67d90056c2c4d5ab747f8b34": LifeCoach,
  "67d90056c2c4d5ab747f8b3f": Parenting,
  "67d90056c2c4d5ab747f8b38": Therapist,
  "67d90056c2c4d5ab747f8b3d": Holistic,
  "67d90056c2c4d5ab747f8b42": TaiChi,
}

export const requiredFields = [
  { name: "price", optional: true },
  { name: "currency", optional: false },
  { name: "timeZone", optional: false },
  { name: "language", optional: false },
  { name: "termsCheck", optional: false },
  { name: "description", optional: false },
  { name: "profilePhoto", optional: false },
  { name: "availability", optional: false },
  { name: "professionalBio", optional: false },
  { name: "gender", label: "Identity" },
  { name: "country" },
  { name: "state" },
  { name: "city" },
  { name: "zip" },

]
export const validationField = {
  "67d90056c2c4d5ab747f8b33": [
    { name: "counselingApproach", optional: false },
    { name: "specializationArea", optional: false },
    { name: "additionalCertificates", optional: true },
    { name: "specializationCertificate", optional: false },
  ],
  "67d90056c2c4d5ab747f8b36": [
    { name: "experience", optional: false },
    { name: "specializationArea", optional: false },
    { name: "trainingBackground", optional: false },
    { name: "additionalCertificates", optional: true },
  ],
  "67d90056c2c4d5ab747f8b40": [
    { name: "experience", optional: false },
    { name: "specializationArea", optional: false },
    { name: "additionalCertificates", optional: true },
    { name: "specializationCertificate", optional: false },
  ],
  "67d90056c2c4d5ab747f8b41": [
    { name: "trainingBackground", optional: false },
    { name: "specializationArea", optional: false },
    { name: "spiritualPractices", optional: false },
    { name: "specializationAreaDescription", optional: false },
  ],
  "67d90056c2c4d5ab747f8b3b": [
    { name: "experience", optional: false },
    { name: "specializationArea", optional: false },
    { name: "additionalCertificates", optional: true },
    { name: "specializationCertificate", optional: false },
  ],
  "67d90056c2c4d5ab747f8b3c": [
    { name: "clienteleFocus", optional: false },
    { name: "trainingBackground", optional: false },
    { name: "specializationArea", optional: false },
  ],
  "67d90056c2c4d5ab747f8b3e": [
    { name: "qualification", optional: false },
    { name: "specializationArea", optional: false },
    { name: "trainingBackground", optional: false },
    { name: "artTherapyTechniques", optional: false },
    { name: "specializationAreaDescription", optional: false },
  ],
  "67d90056c2c4d5ab747f8b37": [
    { name: "experience", optional: false },
    { name: "qualification", optional: false },
    { name: "specializationArea", optional: false },
    { name: "additionalCertificates", optional: true },
  ],
  "67d90056c2c4d5ab747f8b32": [
    { name: "experience", optional: false },
    { name: "clientDemographics", optional: false },
    { name: "specializationArea", optional: false },
    { name: "additionalCertificates", optional: true },
    { name: "specializationCertificate", optional: false },
  ],
  "67d90056c2c4d5ab747f8b35": [
    { name: "experience", optional: false },
    { name: "specializationArea", optional: false },
    { name: "ageGroupPreference", optional: false },
    { name: "additionalCertificates", optional: true },
    { name: "specializationCertificate", optional: false },
  ],
  "67d90056c2c4d5ab747f8b3a": [
    { name: "experience", optional: false },
    { name: "specializationArea", optional: false },
    { name: "additionalCertificates", optional: true },
    { name: "specializationCertificate", optional: false },
  ],
  "67d90056c2c4d5ab747f8b39": [
    { name: "experience", optional: false },
    { name: "specializationArea", optional: false },
    { name: "additionalCertificates", optional: true },
    { name: "specializationCertificate", optional: false },
  ],
  "67d90056c2c4d5ab747f8b34": [
    { name: "targetClientele", optional: false },
    { name: "specializationArea", optional: false },
    { name: "additionalCertificates", optional: true },
    { name: "specializationCertificate", optional: false },
  ],
  "67d90056c2c4d5ab747f8b3f": [
    { name: "experience", optional: false },
    { name: "specializationArea", optional: false },
    { name: "additionalCertificates", optional: true },
    { name: "specializationCertificate", optional: false },
  ],
  "67d90056c2c4d5ab747f8b38": [
    { name: "therapeuticMethods", optional: false },
    { name: "specializationArea", optional: false },
    { name: "specializationCertificate", optional: false },
  ],
  "67d90056c2c4d5ab747f8b3d": [
    { name: "holisticPractices", optional: false },
    { name: "specializationArea", optional: false },
    { name: "trainingBackground", optional: false },
    { name: "specializationCertificate", optional: false },
    { name: "specializationAreaDescription", optional: false },
  ],
  "67d90056c2c4d5ab747f8b42": [
    { name: "qualification", optional: false },
    { name: "taiChiStyles", optional: false },
    { name: "teachingExperience", optional: false },
  ],
}

// export const splId = "67d90056c2c4d5ab747f8b33"
// export const splId = "67d90056c2c4d5ab747f8b36"
// export const splId = "67d90056c2c4d5ab747f8b40"
// export const splId = "67d90056c2c4d5ab747f8b41"
// export const splId = "67d90056c2c4d5ab747f8b3b"
// export const splId = "67d90056c2c4d5ab747f8b3c"
// export const splId = "67d90056c2c4d5ab747f8b3e"
// export const splId = "67d90056c2c4d5ab747f8b37"
export const splId = "67d90056c2c4d5ab747f8b32"
// export const splId = "67d90056c2c4d5ab747f8b35"
// export const splId = "67d90056c2c4d5ab747f8b3a"
// export const splId = "67d90056c2c4d5ab747f8b39"
// export const splId = "67d90056c2c4d5ab747f8b34"
// export const splId = "67d90056c2c4d5ab747f8b3f"
// export const splId = "67d90056c2c4d5ab747f8b38"
// export const splId = "67d90056c2c4d5ab747f8b3d"
// export const splId = "67d90056c2c4d5ab747f8b42"
